// extracted by mini-css-extract-plugin
export var container = "_ja-0";
export var segment = "_ja-2";
export var segmentActive = "_ja-3";
export var track = "_ja-1";